import React, { useCallback, useReducer } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { officeApi } from "../../../api/config";
import { AllianceInsertreducer } from "../../../interface/ActionReducer";
import { AllianceInsertState } from "../../../lib/ReducerStates";
import { ToastChange } from "../../../reducers/config";
import AllianceInsert from "../AllianceInsert";

type Props = {};

/** 새로운 제휴사 등록 페이지 */
const AllianceInsertContainer = (props: Props) => {
  const navigate = useNavigate();
  const reduxPatch = useDispatch();
  const [AllianceInsertData, dispatch] = useReducer(
    AllianceInsertreducer,
    AllianceInsertState
  );
  /** 새로운 제휴사 등록 함수 */
  const InsertNewAlliance = useCallback(() => {
    const { prtn_nm, prtn_use, prtn_info, prtn_desc, thumbnail } =
      AllianceInsertData;
    officeApi
      .post("/cstm/prtn", {
        prtn_nm,
        prtn_use,
        prtn_info,
        prtn_desc,
        thumbnail,
      })
      .then(({ data: { sts_fg, err_msg } }) => {
        if (sts_fg) {
          reduxPatch(
            ToastChange({
              active: true,
              content: "제휴사가 등록되었습니다",
            })
          );
          navigate(-1);
        } else {
          reduxPatch(
            ToastChange({
              active: true,
              content: err_msg,
            })
          );
        }
      })
      .catch(() => {
        reduxPatch(
          ToastChange({
            active: true,
            content: "네트워크 에러",
          })
        );
      });
  }, [navigate, reduxPatch, AllianceInsertData]);

  return (
    <AllianceInsert
      type="new"
      InsertData={InsertNewAlliance}
      data={AllianceInsertData}
      dispatch={dispatch}
    />
  );
};

export default AllianceInsertContainer;
